export const channelMembershipTypes = ['DEFAULT', 'HIDDEN'] as const;
